<script setup>
import { computed } from 'vue';
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  height: {
    type: String,
    default: '200px',
  },
  horizontal: {
    type: Boolean,
    default: false,
  },
});

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const fontFamily =
  '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif';

const defaultOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: props.horizontal ? 'y' : 'x',
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      titleFont: {
        family: fontFamily,
        size: 12,
        weight: '500',
      },
      bodyFont: {
        family: fontFamily,
        size: 11,
      },
      padding: 12,
      cornerRadius: 8,
    },
  },
  scales: {
    x: {
      grid: {
        display: !props.horizontal,
        color: 'rgba(148, 163, 184, 0.1)',
        drawBorder: false,
      },
      ticks: {
        font: {
          family: fontFamily,
          size: 11,
        },
        color: '#94a3b8',
      },
      border: {
        display: false,
      },
    },
    y: {
      grid: {
        display: props.horizontal,
        color: 'rgba(148, 163, 184, 0.1)',
        drawBorder: false,
      },
      ticks: {
        font: {
          family: fontFamily,
          size: 11,
        },
        color: '#94a3b8',
        padding: 8,
      },
      border: {
        display: false,
      },
    },
  },
  elements: {
    bar: {
      borderRadius: 6,
      borderSkipped: false,
    },
  },
}));

const mergedOptions = computed(() => ({
  ...defaultOptions.value,
  ...props.options,
}));
</script>

<template>
  <div :style="{ height }">
    <Bar :data="data" :options="mergedOptions" />
  </div>
</template>
